<template>
    <div v-if="showCollectionSettings" class="containerCollectionSettings">
        <UseDialog :title="l('sksz')" :closeCallBack="closeCallBack" width="605">
            <template #content>
                <div v-loading="loading" class="content">
                    <div ref="needScroll" class="globalCheckBtn needScroll font18">
                        <div>
                            <p v-for="(item,index) in withdrawMoneyMethod" :key="index"
                               @click="changeWithdrawMoneyMethodFn(index)"
                               :class="[currentWithdrawMoneyMethod === index && 'current',`methodsRef${index}`]"
                               class="pointer relative"
                               style="margin-right: 40px;">
                                {{item.name}}</p>
                        </div>
                    </div>
                    <div class="font14" style="margin-top: 10px;">
                        <span style="color:#e53434;margin-right:5px;">*</span>
                        <span class="coloraea28e">{{l('jktj')}}{{withdrawMoneyMethod[currentWithdrawMoneyMethod]?.maximum}}个{{withdrawMoneyMethod[currentWithdrawMoneyMethod]?.name}}{{l('qb')}}</span>
                    </div>
                    <div class="bankList">
                        <template v-if="withdrawMoneyMethod[currentWithdrawMoneyMethod]?.child?.length !== 0">
                            <div @click="changeWithdrawMoneyMethodBankFn(index)"
                                 v-for="(item,index) in withdrawMoneyMethod[currentWithdrawMoneyMethod]?.child"
                                 :key="index" class="item relative transformScale098 borderBox flex alignItemsCenter">
                                <!--                                <div class="flex alignItemsCenter">-->
                                <!--                                    <img style="width:52px;height:52px;" src="/images/withdrawMoney/jia.png" alt="">-->
                                <!--                                </div>-->
                                <div class="font14 flex1 flex column" style="margin-left: 15px;">
                                    <p>
                                        <span class="color6a6153">{{item.bankName}}</span>
                                    </p>
                                    <p class="colorb7874a" style="margin: 10px 0px;">{{item.realName}}</p>
                                    <!--                                    <p class="bold color39270c">{{countShowAccount(item?.cardNum)}}</p>-->
                                    <p class="bold color39270c">{{item?.cardNum}}</p>
                                </div>
                                <!--                                <div v-show="currentWithdrawMoneyMethodBank === index"-->
                                <!--                                     class="currentBank font12 colorb7874a absolute">-->
                                <!--                                    <span>当前</span>-->
                                <!--                                </div>-->
                            </div>
                        </template>
                        <template v-else>
                            <div @click="openAddAccount"
                                 class="item noOne transformScale098 borderBox flex alignItemsCenter">
                                <div class="flex alignItemsCenter">
                                    <img style="width:52px;height:52px;" src="/images/withdrawMoney/jia.png" alt="">
                                </div>
                                <div class="flex1 flex column" style="margin-left: 15px;">
                                    <p style="margin-bottom: 15px;">
                                        <span class="color39270c">{{l('zw')}}{{withdrawMoneyMethod[currentWithdrawMoneyMethod]?.name}}{{l('qb')}}</span>
                                        <span class="color9c896d">{{l('qtj')}}</span>
                                    </p>
                                    <p class="font14 color000">**** **** **** ****</p>
                                </div>
                                <div class="addAccount colorb7874a">
                                    + {{l('xz')}}
                                </div>
                            </div>
                        </template>
                    </div>
                    <template
                            v-if="withdrawMoneyMethod[currentWithdrawMoneyMethod]?.child?.length < withdrawMoneyMethod[currentWithdrawMoneyMethod]?.maximum">
                        <div @click="openAddAccount"
                             class="addNewAccountBtn transformScale098 colorb7874a textAlignCenter">
                            <span>+{{l('tjxd')}}{{withdrawMoneyMethod[currentWithdrawMoneyMethod]?.name}}{{l('qb')}}</span>
                        </div>
                    </template>
                </div>
            </template>
        </UseDialog>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    import BScroll from '@better-scroll/core'

    import {getTellerTagApi, getUserBankApi} from "@/api"

    export default {
        name: "index",
        computed: {
            ...mapState(['showCollectionSettings', 'showAddAccount', 'userInfo']),
        },
        data() {
            return {
                withdrawMoneyMethod: [], //取款方式集合
                currentWithdrawMoneyMethod: '',//当前的取款方式 会采用方法changeWithdrawMoneyMethodFn 默认成0
                currentWithdrawMoneyMethodBank: '',  //当前银行卡
                loading: false,
                scroll: null,   //滚动对象
            }
        },
        watch: {
            showCollectionSettings: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.useInterceptedOnMounted(this.init)
                    } else {
                        this.scroll && this.scroll.destroy()
                        this.scroll = null
                    }
                }, immediate: true
            },
            showAddAccount: {    //监听是否关闭添加界面 关闭的时候刷新一下列表
                handler(newVal, oldVal) {
                    if (!newVal && this.showCollectionSettings) {
                        this.init()
                    }
                }
            }
        },
        methods: {
            init() {
                this.loading = true
                Promise.all([getTellerTagApi(), getUserBankApi()]).then(res => {

                    //失败拦截
                    if (res.filter(item => !item.data).length > 0) return

                    let res0 = res[0].data.result || []
                    let res1 = res[1].data.result || []

                    res0.forEach((item, index) => {
                        if (!item.child) item.child = []

                        res1.forEach((l, i) => {
                            if (l.accountType === item.id) {
                                item.child.push(l)
                            }
                        })
                    })

                    this.withdrawMoneyMethod = [...res0]

                    //默认选中第一项
                    if (!this.scroll) this.currentWithdrawMoneyMethod = 0
                    // this.changeWithdrawMoneyMethodFn(0)

                    setTimeout(() => {
                        this.loading = false

                        if (!this.scroll) {
                            //初始化滚动
                            this.scroll = new BScroll(this.$refs['needScroll'], {
                                click: false,
                                scrollX: true, // 启用横向滚动
                                scrollY: false, // 禁用纵向滚动
                                momentum: true, // 启用惯性滚动
                                bounce: true // 启用回弹效果
                            })
                        } else {
                            //滚动到指定位置
                            this.changeWithdrawMoneyMethodFn(this.currentWithdrawMoneyMethod)
                        }

                    }, 300)
                })
            },
            closeCallBack() {
                this.setStoreState({prop: 'showCollectionSettings', value: false})
            },
            changeWithdrawMoneyMethodFn(index) {  //切换支付方式
                this.currentWithdrawMoneyMethod = index

                //滚动到中间位置
                this.scroll.scrollToElement(`.methodsRef${index}`, 300, true, true)
            },
            changeWithdrawMoneyMethodBankFn(index) { //切换银行卡
                this.currentWithdrawMoneyMethodBank = index
            },
            countShowAccount(str) {
                if (!str) return ''
                // return

                //如果是电话号则中间截取
                const phoneRegex = /^[+]?[0-9]{1,4}?[-.\s]?(\(?\d{1,4}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,9}$/

                if (str.match(phoneRegex)) {
                    return `${str.substr(0, 4)} **** ${str.substr(-4)}`
                }

                return `**** **** **** ${str.substr(-4)}`
            },
            openAddAccount() {
                //判断是否已经绑定了电话号码和真实姓名 没有则提示
                if (!this.userInfo.realName || !this.userInfo.phone) {
                    const _this = this
                    this.$confirm(this.l('nhwbdgrxx'), this.l('ts'), {
                        confirmButtonText: this.l('qbd'),
                        cancelButtonText: this.l('qx'),
                        type: 'warning',
                        // center: true
                    }).then(() => {
                        _this.setStoreState({prop: 'showCollectionSettings', value: false})
                        _this.$router.push({path: '/userCenter/securityCenter'}).catch(err => '')
                    }).catch(() => {

                    })
                    return
                }

                //缓存当前的设置
                sessionStorage.setItem('currentBank', JSON.stringify(this.withdrawMoneyMethod[this.currentWithdrawMoneyMethod]))

                this.setStoreState({prop: 'showAddAccount', value: true})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .containerCollectionSettings {
        .content {
            padding: 20px;

            .needScroll {
                height: 35px;
                white-space: nowrap;
                overflow: hidden;

                > div {
                    display: inline-block;

                    p {
                        display: inline-block;
                    }
                }
            }

            .currentBank {
                top: 10px;
                right: 20px;
                padding: 5px 10px;
                background-color: #f1ede8;
                border-radius: 6px;
                border: solid 1px #b7874a;
            }

            .bankList {
                margin-top: 15px;
                max-height: 200px;
                overflow-y: auto;

                .item {
                    height: 90px;
                    padding: 0px 20px;
                    margin-bottom: 15px;
                    background: url("@images/withdrawMoney/qukuan_bg01.png") no-repeat center center/100% 100%;
                }

                .noOne {
                    .addAccount {
                        padding: 12px 18px;
                        border-radius: 19px;
                        border: solid 1px #b7874a;
                    }
                }
            }

            .addNewAccountBtn {
                height: 47px;
                line-height: 47px;
                border-radius: 10px;
                margin-top: 30px;
                background-color: #eae4dc;
            }
        }
    }
</style>
